import 'configuration/polyfills';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { HelmetProvider } from 'react-helmet-async';
import 'bootstrap/dist/css/bootstrap.css';
import configureStore from 'store/redux/configureStore';
import { initializeSentry } from 'configuration/sentry';
import { initI18n } from 'locales';
import { GlobalErrorBoundary } from 'components';
import App from './App';

const reactQueryClient = new QueryClient();
const store = configureStore();

initializeSentry();

// [PSCS-690] Orders were removed from storage, this is to
// clean up any entries users may still have from before
// the change.
localStorage.removeItem('orders');

const container = document.getElementById('root')!;

const root = createRoot(container);
void initI18n();
root.render(
  <GlobalErrorBoundary>
    <Provider store={store}>
      <HelmetProvider>
        <BrowserRouter>
          <QueryClientProvider client={reactQueryClient}>
            <App />
          </QueryClientProvider>
        </BrowserRouter>
      </HelmetProvider>
    </Provider>
  </GlobalErrorBoundary>
);
unregisterServiceWorkers();

function unregisterServiceWorkers() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      for (const registration of registrations) {
        registration.unregister();
      }
    });
  }
}
